import { Component, Input } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { TeamBookingOverview } from '../../models/team-booking-overview.model';
import { TeamNavigationService } from '../../services/team-navigation.service';

@Component({
    selector: 'app-team-bookings',
    templateUrl: './team-bookings.component.html',
    styleUrls: ['./team-bookings.component.scss'],
})
export class TeamBookingsComponent {
    @Input()
    bookingsTeamOverview: TeamBookingOverview;

    @Input()
    teamId: string;

    @Input()
    teamMemberId: string;

    constructor(private _store: Store, private _teamNavigationService: TeamNavigationService) {}

    openTeamBookingsPage(): void {
        this._teamNavigationService.addTeamPath(window.location.pathname);
        this._store.dispatch(new Navigate([`my-teams/team/${this.teamId}/${this.teamMemberId ? 'member/' + this.teamMemberId + '/' : ''}bookings`]));
    }
}
